export const sharedSentryReplayIntegrationConfig = {
    maskAllText: false,
    blockAllMedia: false,
    mask: ['.sentry-mask, [data-sentry-mask]'],
    block: ['.sentry-block, [data-sentry-block]'],
    networkDetailAllowUrls: [window.location.origin],
    networkRequestHeaders: ['Cookie', 'x-petm-anonymous-key'],
    networkResponseHeaders: ['Set-Cookie'],
};
